import { useState } from 'react';
import { Surface, Badge, Button, Grid, PageHeader } from '../../ui/components';
import { Plus, Eye, Share2 } from 'lucide-react';
import FloatingOwenAssistant from '../../components/common/FloatingOwenAssistant';
import FloatingKnowledge from '../../components/common/FloatingKnowledge';

const mockReferrals = [
  { id: '1', name: 'Real Estate Partners LLC', email: 'contact@repartners.com', total_referrals: 45, converted: 23, earnings: 11500, is_active: true },
  { id: '2', name: 'Home Buyers Network', email: 'info@homebuyers.net', total_referrals: 32, converted: 18, earnings: 9000, is_active: true },
];

const AdminReferrals = () => {
  const [referrals] = useState(mockReferrals);

  return (
    <div>
      <PageHeader
        title="Referral Partners"
        description="Manage referral partner network"
        actions={<Button variant="primary" icon={Plus}>Add Partner</Button>}
      />

      <Grid cols={4} gap="var(--lk-space-4)" style={{ marginBottom: 'var(--lk-space-6)' }}>
        <Surface padding="var(--lk-space-5)">
          <div className="lk-overline" style={{ marginBottom: 4 }}>Total Partners</div>
          <div style={{ fontSize: 'var(--lk-text-2xl)', fontWeight: 700 }}>{referrals.length}</div>
        </Surface>
        <Surface padding="var(--lk-space-5)">
          <div className="lk-overline" style={{ marginBottom: 4 }}>Active Partners</div>
          <div style={{ fontSize: 'var(--lk-text-2xl)', fontWeight: 700, color: 'var(--lk-success-600)' }}>{referrals.filter(r => r.is_active).length}</div>
        </Surface>
        <Surface padding="var(--lk-space-5)">
          <div className="lk-overline" style={{ marginBottom: 4 }}>Total Referrals</div>
          <div style={{ fontSize: 'var(--lk-text-2xl)', fontWeight: 700 }}>{referrals.reduce((sum, r) => sum + r.total_referrals, 0)}</div>
        </Surface>
        <Surface padding="var(--lk-space-5)">
          <div className="lk-overline" style={{ marginBottom: 4 }}>Total Earnings</div>
          <div style={{ fontSize: 'var(--lk-text-2xl)', fontWeight: 700, color: 'var(--lk-primary-600)' }}>${referrals.reduce((sum, r) => sum + r.earnings, 0).toLocaleString()}</div>
        </Surface>
      </Grid>

      <Surface padding="0" style={{ overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table className="lk-table">
            <thead>
              <tr>
                <th>Partner</th>
                <th>Total Referrals</th>
                <th>Converted</th>
                <th>Conversion Rate</th>
                <th>Earnings</th>
                <th>Status</th>
                <th style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {referrals.map((partner) => (
                <tr key={partner.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--lk-space-2)' }}>
                      <div style={{ width: 32, height: 32, borderRadius: 'var(--lk-radius-md)', backgroundColor: 'var(--lk-primary-50)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Share2 size={16} color="var(--lk-primary-500)" />
                      </div>
                      <div>
                        <div style={{ fontWeight: 500 }}>{partner.name}</div>
                        <div style={{ fontSize: 'var(--lk-text-xs)', color: 'var(--lk-text-quaternary)' }}>{partner.email}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ fontWeight: 600 }}>{partner.total_referrals}</td>
                  <td style={{ fontWeight: 600, color: 'var(--lk-success-600)' }}>{partner.converted}</td>
                  <td><Badge variant="primary">{((partner.converted / partner.total_referrals) * 100).toFixed(1)}%</Badge></td>
                  <td style={{ fontWeight: 600 }}>${partner.earnings.toLocaleString()}</td>
                  <td>
                    <Badge variant={partner.is_active ? 'success' : 'neutral'}>
                      {partner.is_active ? 'Active' : 'Inactive'}
                    </Badge>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <Button size="sm" variant="ghost" icon={Eye} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Surface>

      <FloatingOwenAssistant context="admin-referrals" />
      <FloatingKnowledge customContent={{
        label: 'Referrals',
        title: 'Referral partner management',
        body: 'Manage referral partners and track performance.',
        bullets: ['Monitor referral volume', 'Track conversion rates', 'Manage partner accounts'],
        resources: [{ label: 'Partner program', href: '#' }],
      }} />
    </div>
  );
};

export default AdminReferrals;
